// extracted by mini-css-extract-plugin
export var askAiIcon = "_qs-9";
export var container = "_qs-0";
export var groupSeparator = "_qs-a";
export var highlight = "_qs-4";
export var resultIcon = "_qs-5";
export var resultItem = "_qs-7";
export var resultSubtitle = "_qs-3";
export var resultTitle = "_qs-2";
export var resultsList = "_qs-1";
export var searchGroup = "_qs-6";
export var selected = "_qs-8";